import React from 'react';
import PropTypes from 'prop-types';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Components
import VideoPlayer from '../../VideoPlayer';

// Styles
import styles from './videoSection.module.scss';

const VideoSection = ({ job }) => {
  if (!job.extra_info?.job_video) return null;

  return (
    <section id="job-video-section" className={styles.container}>
      {/* {job.extra_info?.job_video_caption && (
        <h2 className={styles.heading}>{job.extra_info?.job_video_caption}</h2>
      )} */}

      <div className={styles.video}>
        <VideoPlayer url={job.extra_info?.job_video} />
      </div>
    </section>
  );
};

VideoSection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
};

export default VideoSection;
